export default "__VITE_ASSET__08cc1d77__"